export default __webpack_public_path__ + "static/media/intro5@3x.77dbda67.jpg";